module.exports = __webpack_public_path__ + "static/media/enfermedades.670b91ba.svg";